

import { Component, Mixins } from 'vue-property-decorator';
import PopupMixin from '~common-mixins/PopupMixin';
import PHeader from './Header.vue';
import PBody from './Body.vue';
import ActionReloader from '~common-components/Popup/Common/ActionReloader.vue';
import { UserLogsModule } from '~/store/modules/userLogs';

@Component({
    components: {
        PHeader,
        PBody,
        ActionReloader,
    },
})
export default class UserLogsPopup extends Mixins(PopupMixin) {
    getUserLogs() {
        UserLogsModule.getUserLogs();
    }
}
